/**
 * Phase 10D: Validation for renewal forms (auto-renewal settings, share, etc.)
 */

/**
 * Validate auto-renewal settings before submit.
 * Returns { isValid, errors }.
 */
export function validateSettings(settings) {
  const errors = {};

  const maxPrice = settings.max_price_increase_percentage ?? settings.maxPriceIncrease ?? 10;
  if (maxPrice < 0 || maxPrice > 100) {
    errors.max_price_increase_percentage = 'Must be between 0-100%';
  }

  const minSavings = settings.min_savings_percentage ?? settings.minSavings ?? 15;
  if (minSavings < 0 || minSavings > 100) {
    errors.min_savings_percentage = 'Must be between 0-100%';
  }

  const allowSwitch = settings.allow_automatic_switching ?? settings.allowAutoSwitch ?? false;
  if (allowSwitch && minSavings < 10) {
    errors.min_savings_percentage = 'Must be at least 10% when auto-switching enabled';
  }

  const maxGap = settings.max_acceptable_gap_days ?? settings.maxGapDays ?? 0;
  if (maxGap < 0 || maxGap > 30) {
    errors.max_acceptable_gap_days = 'Must be between 0-30 days';
  }

  const notifyBefore = settings.notify_before_days ?? settings.notifyBeforeDays ?? 30;
  if (notifyBefore < 7 || notifyBefore > 90) {
    errors.notify_before_days = 'Must be between 7-90 days';
  }

  const channels = settings.notification_channels ?? settings.notificationChannels;
  if (Array.isArray(channels) && channels.length === 0) {
    errors.notification_channels = 'Select at least one notification method';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
}

/**
 * Validate share recommendation form.
 */
export function validateShareForm(data) {
  const errors = {};
  const email = data.recipientEmail ?? data.recipient_email ?? '';
  if (!email || !String(email).trim()) {
    errors.recipientEmail = 'Email required';
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errors.recipientEmail = 'Enter a valid email address';
  }
  const msg = data.personalMessage ?? data.personal_message ?? '';
  if (msg.length > 500) {
    errors.personalMessage = 'Message too long (max 500 characters)';
  }
  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
}

/**
 * Validate multi-policy comparison selection (2-5 policies).
 */
export function validateComparisonSelection(selectedIds, maxCount = 5) {
  const errors = {};
  const count = Array.isArray(selectedIds) ? selectedIds.length : 0;
  if (count < 2) errors.selectedPolicies = 'Select at least 2 policies to compare';
  if (count > maxCount) errors.selectedPolicies = `Compare up to ${maxCount} policies at a time`;
  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
}
